module.exports = __webpack_public_path__ + "static/media/Nekedra J.ba44b06e.jpg";